<template>
  <div ref="parent" class="gamemap">
    <canvas ref="canvas" tabindex="0">

    </canvas>
  </div>
</template>

<script>
import { GameMap } from '@/assets/scripts/GameMap';
import { onMounted, onUnmounted, ref } from 'vue';
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    let parent = ref(null);
    let canvas = ref(null);

    onMounted(() => {
      // 进入前清理可能残留的实例，避免多重渲染导致抖动
      if (store.state.pk.gameObject) {
        store.state.pk.gameObject.on_destroy?.();
        store.state.pk.gameObject.destroy?.();
        store.commit("updateGameObject", null);
      }
      store.commit(
        "updateGameObject",
        new GameMap(canvas.value.getContext('2d'), parent.value, store)
      );
    });

    onUnmounted(() => {
      if (store.state.pk.gameObject) {
        store.state.pk.gameObject.on_destroy?.();
        store.state.pk.gameObject.destroy?.();
        store.commit("updateGameObject", null);
      }
    });

    return {
      parent,
      canvas
    }
  }
}
</script>

<style scoped>
div.gamemap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>